import { BUSINESS_ENTITY_DETAILS_SUBFORM_NAMESPACE as BUSINESS_DETAILS_NAMESPACE } from '@/modules/entities/BusinessEntityDetailsSubform/BusinessEntityDetailsSubform.types';
import { makeBusinessEntityOwnershipStakeInputs } from '@/modules/entities/EntitySubforms/utils/entities/businessEntities.utils';
import { makeAccountInput } from '@/modules/entities/EntitySubforms/utils/shared/accounts.utils';
import {
  AugmentedCreateEntityInput,
  AugmentedCreateSoleProprietorshipBusinessEntityInput,
} from '@/types/schema';

import { EntityShortFormShape } from '../CreateEntityShortForm.types';
import {
  getCreateEntityInputCommonProps,
  getCreateSubtypeInputCommonProps,
  MakeCreateEntityInputParams,
} from './CreateEntityShortForm.common';

function getCreateBusinessEntityInputCommonProperties(
  formInput: EntityShortFormShape,
  householdId: string
): Partial<AugmentedCreateEntityInput> {
  return {
    withOwnedByStakes: makeBusinessEntityOwnershipStakeInputs(
      formInput,
      householdId
    ),
  };
}

export function makeCreateSoleProprietorshipInput(
  formInput: EntityShortFormShape,
  householdId: string,
  params: MakeCreateEntityInputParams
): AugmentedCreateEntityInput {
  const input: AugmentedCreateEntityInput = {
    create: {
      ...getCreateEntityInputCommonProps(formInput, householdId, params),
    },
    ...getCreateBusinessEntityInputCommonProperties(formInput, householdId),
    withSoleProprietorshipBusinessEntity: makeBusinessEntityInput(
      formInput,
      householdId
    ),
  };

  return input;
}

export function makeCreateLLCInput(
  formInput: EntityShortFormShape,
  householdId: string,
  params: MakeCreateEntityInputParams
): AugmentedCreateEntityInput {
  const input: AugmentedCreateEntityInput = {
    create: {
      ...getCreateEntityInputCommonProps(formInput, householdId, params),
    },
    ...getCreateBusinessEntityInputCommonProperties(formInput, householdId),
    withLlcBusinessEntity: makeBusinessEntityInput(formInput, householdId),
  };

  return input;
}
export function makeCreateCCorpInput(
  formInput: EntityShortFormShape,
  householdId: string,
  params: MakeCreateEntityInputParams
): AugmentedCreateEntityInput {
  const input: AugmentedCreateEntityInput = {
    create: {
      ...getCreateEntityInputCommonProps(formInput, householdId, params),
    },
    ...getCreateBusinessEntityInputCommonProperties(formInput, householdId),
    withCcorpBusinessEntity: makeBusinessEntityInput(formInput, householdId),
  };

  return input;
}
export function makeCreateSCorpInput(
  formInput: EntityShortFormShape,
  householdId: string,
  params: MakeCreateEntityInputParams
): AugmentedCreateEntityInput {
  const input: AugmentedCreateEntityInput = {
    create: {
      ...getCreateEntityInputCommonProps(formInput, householdId, params),
    },
    ...getCreateBusinessEntityInputCommonProperties(formInput, householdId),
    withScorpBusinessEntity: makeBusinessEntityInput(formInput, householdId),
  };

  return input;
}
export function makeCreateGPInput(
  formInput: EntityShortFormShape,
  householdId: string,
  params: MakeCreateEntityInputParams
): AugmentedCreateEntityInput {
  const input: AugmentedCreateEntityInput = {
    create: {
      ...getCreateEntityInputCommonProps(formInput, householdId, params),
    },
    ...getCreateBusinessEntityInputCommonProperties(formInput, householdId),
    withGpBusinessEntity: makeBusinessEntityInput(formInput, householdId),
  };

  return input;
}
export function makeCreateLPInput(
  formInput: EntityShortFormShape,
  householdId: string,
  params: MakeCreateEntityInputParams
): AugmentedCreateEntityInput {
  const input: AugmentedCreateEntityInput = {
    create: {
      ...getCreateEntityInputCommonProps(formInput, householdId, params),
    },
    ...getCreateBusinessEntityInputCommonProperties(formInput, householdId),
    withLpBusinessEntity: makeBusinessEntityInput(formInput, householdId),
  };

  return input;
}

function makeBusinessEntityInput(
  formInput: EntityShortFormShape,
  householdId: string
): AugmentedCreateSoleProprietorshipBusinessEntityInput {
  return {
    create: {
      ...getCreateSubtypeInputCommonProps(formInput, householdId),
      ownershipAsOfDate:
        formInput[BUSINESS_DETAILS_NAMESPACE].ownershipAsOfDate,
    },
    withDesignerAccount: makeAccountInput(formInput, householdId),
  };
}
